import {combineReducers} from "redux"
import {getCostProjection} from "../../modules"
import templates from "./templates"

// SELECTORS
export const getReport = (state) => getCostProjection(state).report

// REDUCER
export default combineReducers({
  templates,
})
